import React from 'react';
import { Stack } from '@mui/material';
import { translateThis } from '../../../helpers/language.helper';


export const PasswordRequirementCheckBoxes = ({ rules }) => {
    
    return (
        <Stack className='password-requirement-points' variant='div' spacing={3} style={{ marginTop: '0' }}>
            <ul>
                <li className={rules.eightCharacter ? 'checked' : ''}>{translateThis('At least 8 characters long')}</li>
                <li className={rules.containNumber ? 'checked' : ''}>{translateThis('1 number')}</li>
                <li className={rules.containUpperCase ? 'checked' : ''}>{translateThis('1 uppercase character')}</li>
                <li className={rules.containSpecialChar ? 'checked' : ''}>{translateThis('1 special symbol')}</li>
            </ul>
        </Stack>
    )
}